import Button from '@rio-cloud/rio-uikit/Button';
import ExpanderPanel from '@rio-cloud/rio-uikit/ExpanderPanel';
import { FormattedMessage } from 'react-intl';
import { RoleAccessRights } from './RoleAccessRights';
import { type RoleDefinition, Service, type Services } from './RoleAccessMatrix.ts';

const generateList = (services: Services) => (
    <ul className={'list-group'}>
        {Object.entries(services).map(([serviceName, access]) => (
            <li className={'list-group-item'} key={serviceName}>
                <div className={'display-flex justify-content-between align-items-center'}>
                    <span>
                        <FormattedMessage id={Service[serviceName as keyof typeof Service]} />
                    </span>
                    <RoleAccessRights access={access.access} details={access.details} />
                </div>
            </li>
        ))}
    </ul>
);

interface Props {
    role: RoleDefinition;
    switchToOverview: () => void;
}

export const RoleDescription = ({ role, switchToOverview }: Props) => (
    <div>
        <Button iconName='chevron-left' onClick={switchToOverview} autoTrackingKey='infoDialog.concepts.roles.back'>
            <FormattedMessage id={'infoDialog.concepts.roles.back'} />
        </Button>
        <h4>
            <FormattedMessage id={role.title} />
        </h4>
        <p>{<FormattedMessage id={role.description} />}</p>
        <div className='callout callout-info text-color-darker margin-bottom-20'>
            {
                <FormattedMessage
                    id={role.scope}
                    values={{
                        b: chunks => <strong>{chunks}</strong>,
                    }}
                />
            }
        </div>
        <div className={'padding-top-5'}>
            <ExpanderPanel
                title={<FormattedMessage id={'roles.description.services'} defaultMessage='Services' />}
                bsStyle='default'
                bodyClassName='padding-top-5 padding-x-0'
                open
            >
                {generateList(role.services)}
            </ExpanderPanel>
            <ExpanderPanel
                title={<FormattedMessage id={'roles.description.adminServices'} />}
                bsStyle='default'
                bodyClassName='padding-y-5 padding-x-0'
                className='margin-top-10'
                open
            >
                {role.adminServices ? (
                    generateList(role.adminServices)
                ) : (
                    <div className='padding-x-15 padding-y-10'>
                        <FormattedMessage id={'roles.description.noAdminServices'} />
                    </div>
                )}
            </ExpanderPanel>
        </div>
    </div>
);
